export const setcallstatus = (data) =>({
    type:'SET_CALLSTATUS',
    payload:data,
  })  